export default "__VITE_ASSET__B1GNiPq5__"